export function LocationMarkerIcon({
  className = 'text-fx-neutral-600',
}: {
  className?: string;
}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.7713 11.1046C10.767 12.1089 8.00002 14.8758 8.00002 14.8758C8.00002 14.8758 5.30729 12.1831 4.22878 11.1046C2.14599 9.02177 2.14599 5.64489 4.22878 3.5621C6.31158 1.4793 9.68846 1.4793 11.7713 3.5621C13.8541 5.64489 13.8541 9.02177 11.7713 11.1046Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.33333C10 8.4379 9.10459 9.33333 8.00002 9.33333C6.89545 9.33333 6.00002 8.4379 6.00002 7.33333C6.00002 6.22876 6.89545 5.33333 8.00002 5.33333C9.10459 5.33333 10 6.22876 10 7.33333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
